export default {
  /* 加工模块 */
  createProcessing: { // 新增加工过程
    url: '/api/createProcessing',
    method: 'post'
  },
  updateProcessing: { // 修改加工过程
    url: '/api/updateProcessing',
    method: 'put'
  },
  deleteProcessing: { // 删除工艺
    url: '/api/deleteProcessing',
    method: 'delete'
  },
  deleteProcessingProcess: { // 删除工序
    url: '/api/deleteProcessingProcess',
    method: 'delete'
  },
  getProcessing: { // 查询加工过程
    url: '/api/getProcessing',
    method: 'get'
  },
  /* 包装模块 */
  createPackingManagementJL: { // 新增包装
    url: '/api/createPackingManagementJL',
    method: 'post'
  },
  updatePackingManagement: { // 修改包装
    url: '/api/updatePackingManagement',
    method: 'put'
  },
  getPackingManagementJL: { // 查询包装
    url: '/api/getPackingManagementJL',
    method: 'get'
  },
  deletePackingManagementJL: { // 删除包装
    url: '/api/deletePackingManagementJL',
    method: 'delete'
  },
  getPackingTraceByTraceCode: { // 根据追溯码查询
    url: '/api/getPackingTraceByTraceCode',
    method: 'get'
  },
  getPackingTraceByTraceCodeJL: { // 根据追溯码查询
    url: '/api/getPackingTraceByTraceCodeJL',
    method: 'get'
  },
  /* 检测报告模块 */
  createTestReport: { // 新增检测报告
    url: '/api/createTestReport',
    method: 'post'
  },
  updateTestReport: { // 修改检测报告
    url: '/api/updateTestReport',
    method: 'put'
  },
  savePackingTrace: { // 保存追溯信息
    url: '/api/savePackingTrace',
    method: 'post'
  },
  savePackingTraceJL: { // 保存追溯信息
    url: '/api/savePackingTraceJL',
    method: 'post'
  },
  deleteTestReport: { // 删除检测报告
    url: '/api/deleteTestReport',
    method: 'delete'
  }
}
